// Services
import puppySellService from '@/app/services/main/puppy-sell/puppy-sell-service.js'

// Mixins
import { toastMessageMixins } from '@/app/mixins/utils/toast-message-mixins';
import { inputTextMixins } from '@/app/mixins/utils/input-text-mixins';
import { userMixins } from '@/app/mixins/modules/user-mixins.js';
import { tableMixins } from "@/app/mixins/utils/table-mixins.js";
import { GoogleAnalyticsMixins } from '@/app/mixins/utils/google-analytics-mixins';

// Constants
import { STATUS_CODES } from '@/app/constants/status-constants';

export default {
    name: 'PuppyPurchaseListingContainer',
    mixins: [
        inputTextMixins,
        toastMessageMixins,
    userMixins,
        tableMixins,
        GoogleAnalyticsMixins
    ],
    data() {
        return {
            breedList: [],
            isAPILoading: false,
            isLoadMoreLoading: false,
            showNoResult: false,
            noPuppyPurchased: false,
            modalContent: {},
            puppyPurchasedList: [],
            page: 1,
            limitFilter: 6,
            increment: 6,
            breedId: '',
            storeCredit: parseInt(process.env.VUE_APP_STORE_CREDIT),
        };
    },
    watch: {
        selectedType() {
            this.dogPurchaseList(false, true);
        },
        breedId() {
            this.dogPurchaseList(false, true);
        },
    },
    created() {
        this.getPuppyPurchasedList(false);
    },
    methods: {
        async getPuppyPurchasedList(isLoadMore) {
            if(!isLoadMore) {
                this.isAPILoading = true;
            }
            let queryParams = {
                page: this.page,
                limit: this.increment,
                sortBy: '',
                desc: true
            };
            try {
                const response = await puppySellService.getPuppyPurchasedList(queryParams)
                if (response.status === STATUS_CODES.SUCCESS) {
                    isLoadMore ? this.puppyPurchasedList.push(...response.data.data) : this.puppyPurchasedList = response.data.data
                    response.data.pagination.totalCount && response.data.pagination.totalCount > this.limitFilter ? this.showNoResult = false : this.showNoResult = true;
                    !this.puppyPurchasedList.length ? this.noPuppyPurchased = true :this.noPuppyPurchased = false
                }
                else {
                    this.showAPIErrorToast('Unable to fetch puppy purchased list.', response);
                    this.isAPILoading = false;
                    this.isLoadMoreLoading = false;
                }
                this.isAPILoading = false;
                this.isLoadMoreLoading = false;
            } catch (error) {
                this.showGenericErrorToast();
                this.isAPILoading = false;
                this.isLoadMoreLoading = false;
            }
        },

        puppyPurchasedStatusColor(status) {
            const statusMap = {
                ["A"]: "status--green",
                ["PP"]: "status--blue",
                ["REQUEST_REFUND"]: "status--blue",
                ["PICKED_UP"]: "status--green",
                ["S"]: "status--grey",
                ["REFUNDED"]: "status--grey",
                ["CANCELED"]: "status--red",
                ["DECLINED"]: "status--red"
            };

            return statusMap[status] || "status--grey";
        },
    
        loadMore() {
            this.isLoadMoreLoading = true;
            this.page++;
            this.limitFilter += this.increment;
            this.getPuppyPurchasedList(true);
        },
    },
}